import axios from "axios";
import Cookies from "js-cookie";
import { Message } from 'element-ui';
import store from '../store'

const NODE_ENV = process.env.NODE_ENV;
// 动态获取
const URLADDRES = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/yspplatform';
const BASEURL =
    NODE_ENV === "development" ? "/api" : URLADDRES;

const tip = message => {
    Message.error(message || "请求超时");
};

const http = axios.create({
    baseURL: BASEURL,
    timeout: 15000,
    // 允许自动携带cookie
    withCredentials: true
});

// 添加请求拦截器
http.interceptors.request.use(
    function (config) {
        let token = Cookies.get('token') || "";
        if (token) {
            config.headers["token"] = token || "";
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// 添加响应拦截器
http.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            return Promise.reject(response.data);
        }
    },
    error => {
        let { response } = error;
        if (response) {
            let { respStatusNo, data, respStatusInfo } = response.data;
            // 处理token失效 返回登录页
            if (respStatusInfo == "token无效") {
                console.log('token无效');
                // this.$router.push({
                // 	path: "/login",
                // });
            }
            errorHandler(response.status, respStatusInfo || "连接超时");
        } else {
            // 处理断网等
        }
        return Promise.reject(error);
    }
);

export default http;